import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewContainerRef,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { Portfolio } from 'src/app/features/portfolio/portfolio.model'
import { MoneyMarketCharacteristic } from 'src/app/models/characteristic-response.model'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'

@Component({
  selector: 'money-market-characteristic',
  templateUrl: './money-market-characteristic.component.html',
  styleUrls: ['./money-market-characteristic.component.scss'],
  providers: [],
})
export class MoneyMarketCharacteristicComponent implements OnInit, OnDestroy {
  @Input() portfolioModel: Portfolio
  @Input() fundId: string
  moneyMarketCharacteristic: MoneyMarketCharacteristic
  noCharacteristicsData = false
  public title = ''

  //AEM content variables
  averageMaturity: AEMChunk
  alternativeMinimumTax: AEMChunk
  aemContentSub: Subscription

  constructor(
    private readonly viewContainer: ViewContainerRef,
    private readonly centralContentService: CentralContentService,
  ) {}

  ngOnInit(): void {
    this.moneyMarketCharacteristic =
      this.portfolioModel?.characteristic?.moneyMarketCharacteristic

    if (
      this.moneyMarketCharacteristic !== null &&
      this.moneyMarketCharacteristic !== undefined
    ) {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      this.noCharacteristicsData =
        Object.keys(this.moneyMarketCharacteristic).length === 0 ? true : false
    }

    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }

  parseAEMContent(content) {
    this.averageMaturity = this.centralContentService.getContentByBody(
      'fund_definitions_average_maturity',
      content,
    )
    this.alternativeMinimumTax = this.centralContentService.getContentByBody(
      'fund_definitions_alternative_minimum_tax',
      content,
    )
  }

  public setDialogInfo(type = ' ') {
    this.title = type
  }

  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }
}
